import SanctionBanner from "./SanctionBanner";

export default SanctionBanner;
